import { Outlet } from "react-router-dom"

import { FeaturesMandala } from "@/components/auth/features-mandala"
import Providers from "@/providers"
export function AuthLayout() {
  return (
    <Providers>
      <main className="relative flex min-h-screen">
        {/* Left side - Mandala com features */}
        <div
          className="relative hidden flex-col overflow-hidden text-white md:flex md:w-[30%]"
          style={{
            backgroundColor: "var(--whitelabel-primary)",
          }}
        >
          {/* Background decorativo com efeito de luz */}
          <div className="pointer-events-none absolute inset-0">
            <div
              className="absolute -left-40 top-20 h-[500px] w-[500px] rounded-full opacity-20 blur-[120px]"
              style={{
                backgroundColor:
                  "var(--whitelabel-primary)",
              }}
            />
            <div className="absolute -right-40 bottom-20 h-[400px] w-[400px] rounded-full bg-white/10 blur-[100px]" />
          </div>
          {/* Conteúdo centralizado */}
          <div className="relative z-10 flex flex-1 flex-col items-center justify-center px-8 lg:px-12">
            {/* Mandala */}
            <div className="mb-8">
              <FeaturesMandala />
            </div>
            {/* Texto */}
            <div className="max-w-sm space-y-3 text-center">
              <h2 className="text-2xl font-bold leading-tight lg:text-3xl">
                Tudo que você precisa em um só lugar
              </h2>
              <p className="text-sm text-white/80 lg:text-base">
                Gerencie pedidos, assinaturas, webhooks e
                muito mais com a plataforma mais completa do
                mercado.
              </p>
            </div>
          </div>
          {/* Footer */}
          <div className="relative z-10 py-6 text-center">
            <p className="text-sm text-white/70">
              © {new Date().getFullYear()} Pay2B. Todos os
              direitos reservados.
            </p>
          </div>
        </div>
        {/* Right side - Form */}
        <div className="flex w-full flex-col items-center justify-center bg-background px-6 py-12 md:w-[80%]">
          <Outlet />
        </div>
      </main>
    </Providers>
  )
}
